import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { routes } from '../../../config/routes';
import { CONSTANTS } from '@tpco/tpco-saturn-types';
import ComponentWithDecorator from './ComponentWithDecorator';

const RenderProtectedRoutes = ({
  component: Component,
  path,
  exact,
  isAdminUserAuth,
  access_control,
  claims,
  client
}) => {
  let exact_value = !(exact === 'exact');
  console.log(path);
  let route = (
    <Route
      exact={exact_value}
      path={path}
      render={matchProps => (
        <ComponentWithDecorator {...matchProps} Component={Component} client={client} isAdminUserAuth={isAdminUserAuth}/>
      )}
    />
  );
  //if the user is not an admin then they either have restricted access or modified access
  if (!isAdminUserAuth) {
    switch (access_control) {
      case CONSTANTS.ACCESS_CONTROL.RESTRICTED_ACCESS:
        route = (
          <Route
            exact={exact_value}
            path={path}
            render={matchProps =>
              !isAdminUserAuth ? (
                <Redirect to="/error" />
              ) : (
                <ComponentWithDecorator {...matchProps} Component={Component} client={client} isAdminUserAuth={isAdminUserAuth} />
              )
            }
          />
        );

        break;
      case CONSTANTS.ACCESS_CONTROL.MODIFIED_ACCESS:
        route = (
          <Route
            exact={exact_value}
            path={path}
            render={matchProps => {
            return  <ComponentWithDecorator {...matchProps} Component={Component} client={client} />
              // return !claims.find(x => x == matchProps.match.params.tgramsId) ? (
              //   <Redirect to="/error" />
              // ) : (
              //   <ComponentWithDecorator {...matchProps} Component={Component} client={client} />
              // );
            }}
          />
        );
        break;
    }
  }
  return route;
};

interface IState {
  isUserAuth: boolean;
}
class SiteContent extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
  }

  render() {
    const { isAdminUserAuth, claims, client } = this.props;

    console.log({ description: `SiteContent` });

    return (
      <Switch>
        {routes.map((route, i) => (
          <RenderProtectedRoutes
            key={`${route.name} ${i}`}
            path={route.path}
            component={route.component}
            exact={route.exact}
            isAdminUserAuth={isAdminUserAuth}
            claims={claims}
            access_control={route.checkAccess}
            client={client}
          />
        ))}
      </Switch>
    );
  }
}

export default SiteContent;
